module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('img', {
    staticClass: "showMobile",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/mothersday-image-desktop.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "over-lay text-left"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "main-heading"
  }, [_c('button', {
    staticClass: "btn btn-primary main-heading-btn btn-lg showMobile",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_vm._v("Give the Gift of TONE")]), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": 'Give the Gift of Knowledge and Empowerment',
      "description": _vm.sharingDescription,
      "title": _vm.sharingTitle
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "socialicons"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('ul', [(_vm.dynamic_para_1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_1)
    }
  }) : _vm._e(), _c('br')]), _vm._v(" "), (_vm.dynamic_para_2) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_2)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', [(_vm.dynamic_para_3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_3)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.dynamic_button_1 && _vm.dynamic_button_1 !== ' ') ? _c('button', {
    staticClass: "btn btn-primary main-heading-btn btn-lg hideMobile",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.dynamic_button_1))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.currentPlayerID) ? _c('div', {
    staticClass: "col-sm-offset-4 col-sm-3 vedioplayerholder showMobile"
  }, [_c('jwplayer', {
    attrs: {
      "id": "showGiftingMobile",
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container text-left"
  }, [_c('div', {
    staticClass: "row aboutrow"
  }, [_c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.giftPlans) ? _c('div', {
    staticClass: "gifts row"
  }, _vm._l((_vm.giftPlans), function(plan) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "gift-item"
    }, [_c('h5', [_c('strong', [_vm._v("Gift of TONE")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(plan.description))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.setPackage(plan)
        }
      }
    }, [_vm._v("Buy Now: $" + _vm._s(plan.amountFmt))])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.currentPlayerID2) ? _c('div', {
    staticClass: "vedioplayerholder hideMobile"
  }, [_c('jwplayer', {
    attrs: {
      "id": "showGiftingDesktop",
      "data": _vm.currentPlayerID2
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.dynamic_para_4) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_para_5) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_5)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tonepoints"
  }, [(_vm.dynamic_bullet_1) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_2) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_bullet_3) ? _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_bullet_3)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.dynamic_para_6) ? _c('p', {
    staticStyle: {
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_6)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_promotion_img && _vm.dynamic_promotion_img.length > 5) ? _c('img', {
    staticStyle: {
      "max-width": "50%",
      "margin": "20px auto",
      "float": "none",
      "clear": "both",
      "display": "block"
    },
    attrs: {
      "src": _vm.dynamic_promotion_img,
      "alt": _vm.dynamic_para_7,
      "title": _vm.dynamic_para_7
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dynamic_para_7) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.dynamic_para_7)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2f5d7ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Gifts.vue